const initState = {
  books: [],
  series: [],
  categories: [],
  collections: [],
  tags: [],
  roles: [],
  stickers: [],
  banners: [],
  notice: [],
  faceStickers: [],
  soundEffects: [],
};

const dataReducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE_BOOKS_DATA":
      return {
        ...state,
        books: action.payload.data,
      };
    case "UPDATE_SERIES_DATA":
      return {
        ...state,
        series: action.payload.data,
      };
    case "UPDATE_CATEGORIES_DATA":
      return {
        ...state,
        categories: action.payload.data,
      };
    case "UPDATE_COLLECTIONS_DATA":
      return {
        ...state,
        collections: action.payload.data,
      };
    case "UPDATE_TAGS_DATA":
      return {
        ...state,
        tags: action.payload.data,
      };
    case "UPDATE_ROLES_DATA":
      return {
        ...state,
        roles: action.payload.data,
      };
    case "UPDATE_STICKERS_DATA":
      return {
        ...state,
        stickers: action.payload.data,
      };
    case "UPDATE_BANNERS_DATA":
      return {
        ...state,
        banners: action.payload.data,
      };
    case "UPDATE_NOTICE_DATA":
      return {
        ...state,
        notice: action.payload.data,
      };
    case "UPDATE_FACESTICKERS_DATA":
      return {
        ...state,
        faceStickers: action.payload.data,
      };
    case "UPDATE_SOUNDEFFECTS_DATA":
      return {
        ...state,
        soundEffects: action.payload.data,
      };
    default:
      return state;
  }
};

export default dataReducer;
